// import 'moment/dist/locale/nl';
import 'moment/dist/locale/es';
import 'moment/dist/locale/pt';
import 'moment/dist/locale/ru';

import en from './lib/en.json';
import es from './lib/es.json';
import pt from './lib/pt.json';
import overridesEn from './region-overrides/en.json';
import presetsEn from './school-presets/en/presets.json';
import presetsPt from './school-presets/pt/presets.json';

export const DEFAULT_LANGUAGE_CODE: SupportedLangCode = 'en';

export type SupportedLangCode = 'en' | 'es' | 'pt';

export const MESSAGES_BY_LANG_CODE: { [k in SupportedLangCode]: Record<string, string> } = {
  en,
  es,
  pt,
};

export const isSupportedLangCode = (v: string): v is SupportedLangCode => {
  return Object.keys(MESSAGES_BY_LANG_CODE).includes(v);
};

export const SCHOOL_PRESETS_BY_LANG_CODE = {
  en: presetsEn,
  pt: presetsPt,
};

type Overrides = {
  [countryCode: string]: {
    [key: string]: string;
  };
};

type RegionOverridesByLangCode = {
  [langCode: string]: Overrides;
};

export const REGION_OVERRIDES_BY_LANG_CODE: RegionOverridesByLangCode = {
  en: overridesEn,
};
